import { BankNumbersController } from './bankNumbers.controller';
import template from './bankNumbers.html';

export const createRequestBankNumbersComponent = {
  name: 'createRequestBankNumbers',
  restrict: 'E',
  template,
  controller: BankNumbersController,
  controllerAs: 'vm',
  bindings: {
    descriptionTitle: '@',
    descriptionText: '@',
    model: '=',
    form: '=',
  },
};
